import { Tag } from 'antd';
import { REPORT_PACK_STATUS } from '../../../../../../../constants/accounting';

export function ReportPackStatusTag({ status }: { status: string }) {
  if (status === REPORT_PACK_STATUS.Ready)
    return <Tag color="green">Ready</Tag>;
  if (status === REPORT_PACK_STATUS.Generating)
    return <Tag color="processing">Generating</Tag>;
  if (status === REPORT_PACK_STATUS.Failed)
    return <Tag color="error">Failed</Tag>;
  return <Tag>{status}</Tag>;
}
